import { useState, useEffect, useCallback } from 'react';
import Page from 'component/Page';
import Table from 'component/Table';
import Modal from 'component/Modal';
import { Form, Row, Button } from 'react-bootstrap';
import FormControls from 'component/FormControls';
import string from 'util/string';
import Urls from 'util/urls';
import { sendPost } from 'util/request';
import {
	nNU,
	formatDate,
	showConfirm,
	showToast,
} from 'util/utils';
import moment from 'moment';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';

const contentTable = [
	"顧客番号",			// 0
	"郵便番号",			// 1
	"住所１",				// 2
	"住所２",				// 3
	"住所３",				// 4
	"契約者名漢字",		// 5
	"初回請求額",			// 6
	"通常請求額",			// 7
	"変動金額",				// 8
	"加減算額",				// 9
	"当月消費税額",		// 10
	"未収累計額",			// 11
	"当月請求額",			// 12
	"通常請求額1",		// 13
	"通常請求額2",		// 14
	"通常請求額3",		// 15
	"通常請求額4",		// 16
	"通常請求額5",		// 17
	"変動金額1",			// 18
	"変動金額2",			// 19
	"変動金額3",			// 20
	"変動金額4",			// 21
	"変動金額5",			// 22
];
const invoiceTable = [
	"データ",					// 0
	"データ",					// 1
	"データ",					// 2
	"データ",					// 3
	"データ",					// 4
	"データ",					// 5
	"初回請求額",			// 6
	"小計 (10.0%対象)",					// 7
	"未定",						// 8
	"加減算額",						// 9
	"消費税 (10.0%対象)",					// 10
	"未収累計額",						// 11
	"合計額",					// 12
	"IP無線利用料",						// 13
	"アプリ利用料",		// 14
	"安心パック",			// 15
	"未定",						// 16
	"未定",						// 17
	"開設手数料",				// 18
	"未定",						// 19
	"未定",						// 20
	"未定",						// 21
	"未定",						// 22
];
const itemIndexTable = [
	6,			// 1
	13,			// 2
	14,			// 3
	15,			// 4
	18,			// 5
	0,			// 6
	0,			// 7
	0,			// 8
	0,			// 9
	9,			// 10
	7,			// 11
	10,			// 12
	11,			// 13
	12,			// 14
];
const transferDate = [
	'20日',
	'21日',
	'22日',
	'23日',
	'24日',
	'25日',
	'26日',
];
const weeksDay = [
	'日',
	'月',
	'火',
	'水',
	'木',
	'金',
	'土',
];
const csvHeaderTable = [
	"顧客番号",
	"預金者名ｶﾅ",
	"預金者名漢字",
	"銀行番号",
	"銀行名漢字",
	"支店番号",
	"支店名漢字",
	"預金種目",
	"口座番号",
	"郵便番号1",
	"郵便番号2",
	"住所１",
	"住所２",
	"住所３",
	"電話番号",
	"契約者名ｶﾅ",
	"契約者名漢字",
	"初回請求額",
	"通常請求額",
	"変動金額",
	"加減算額",
	"当月消費税額",
	"未収累計額",
	"当月請求額",
	"通常請求額1",
	"通常請求額2",
	"通常請求額3",
	"通常請求額4",
	"通常請求額5",
	"変動金額1",
	"変動金額2",
	"変動金額3",
	"変動金額4",
	"変動金額5",
	"新規・照合コード",
	"満了者コード",
	"振替結果コード",
];

const SendInvoice = () => {
  //-------------------------------HOOKS-------------------------------------------------------------
	const [csvFile, setCsvFile] = useState();
	const [csvContent, setCsvContent] = useState([]);
	const [total, setTotal] = useState();
	const [invoice, setInvoice] = useState([]);
	const [selectDate, setSelectDate] = useState([]);
	const [selectedDate, setSelectedDate] = useState();
	const fileReader = new FileReader();
	const [inputFile, setInputFile] = useState(null);
	const [errorId, setErrorId] = useState(null);
	const currentUser = useSelector(selectCurrentUser);
  const isMonitorOnly = useMemo(
    () => currentUser.isMonitorOnly === 1,
    [ currentUser.isMonitorOnly ]
  );

  //------------------------FUNCTIONS----------------------------------------------------------
	const onCsvImport = (e) => {
		// setCsvFile(e.target.files[0]);
    // e.preventDefault();
    // e.stopPropagation();

		const file = e.target.files[0];
		if (file) {
			fileReader.onload = function (e) {
				const csvOutput = e.target.result;
				if (csvFileToArray(csvOutput)) {
					setCsvFile(file);
				} else {
					setCsvFile(null);
					showToast("CSV file error","error");
				}
			};
			fileReader.readAsText(file, 'MS932');
			// fileReader.readAsText(file, 'UTF-8');
			// fileReader.readAsText(file,'RFC-4180');
			// fileReader.readAsText(file,'UTF-16 LE');
			// setCsvFile(file);
		} else {
			setCsvContent([]);
			setTotal(0);
			setCsvFile(null);
		}
	};
	const handleUpload = () => {
		inputFile?.click();
	};
  const csvFileToArray = string => {
		const regex = new RegExp(/[（）]/g);
    const csvHeader = string.slice(0, string.indexOf("\n")).replace(regex,'').split(",");
    const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");
		if (csvHeader.length !== (csvHeaderTable.length + 1)) {
			setCsvContent([]);
			setTotal(0);
			return false;
		} else {
			let check = [];
			csvHeaderTable.map((value) => (check.push(value)));
			check.push(csvHeader[csvHeader.length-1]);
			const checkCsv = JSON.stringify(check);
			const inputCsv = JSON.stringify(csvHeader);
			if (checkCsv !== inputCsv) {
				setCsvContent([]);
				setTotal(0);
				return false;
			} else {
				const array = csvRows.map(i => {
					const prices = i.split("\"");
					const rowData = prices.map(price => {
						const firstComma = price.indexOf(",");
						const lastComma = price.lastIndexOf(",");
						let data = price;
						if ((lastComma === firstComma) && (firstComma > 0)) {
							data = data.replace(",",'@');
						}
						return data;
					});
					let rowStr = "";
					for(let i=0;i<rowData.length;i++) {
						rowStr = rowStr + rowData[i];
					}
					// const counts = i.search("\"");
					const values = rowStr.split(",");
					const obj = csvHeader.reduce((object, header, index) => {
						object[header] = values[index];
						return object;
					}, {});
					return obj;
				});
				const arrayLength = array.length;
				let rowCount = 0;
				if (arrayLength > 2) {
					rowCount = arrayLength - 2;
				} else if(arrayLength > 1){
					rowCount = arrayLength - 1;
				} else {
					rowCount = arrayLength;
				}
				setCsvContent(array);
				setTotal(rowCount);
				return true;
			}
		}
  };
	const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
		// if (csvFile) {
		// 	fileReader.onload = function (e) {
		// 		const csvOutput = e.target.result;
		// 		csvFileToArray(csvOutput);
		// 	};
		// 	fileReader.readAsText(csvFile, 'MS932');
		// }

		if (!!nNU(csvContent) && (total > 0)) {
			console.log("Loaded");
			setInvoice(invoiceData(csvContent));
		}

	}
	const invoiceData = useCallback(
		(data) =>
			data.map((raw, key) => ({
				key: raw?.顧客番号,
				data: !!nNU(raw?.契約者名漢字) && (raw?.契約者名漢字 !== '') ? [
					!!(raw?.顧客番号) ? raw?.顧客番号:"",
					!!nNU(raw?.郵便番号1) && !!nNU(raw?.郵便番号2) ? `〒 ${raw?.郵便番号1}-${raw?.郵便番号2}`: "",
					!!nNU(raw?.住所１) ? raw?.住所１:"",
					!!nNU(raw?.住所２) ? raw?.住所２:"",
					!!nNU(raw?.住所３) ? raw?.住所３:"",
					!!nNU(raw?.契約者名漢字) && (raw?.契約者名漢字 !== '') ? raw?.契約者名漢字:"",
					!!nNU(raw?.初回請求額) && (raw?.初回請求額 !== '') ? `￥${raw?.初回請求額.replace("@",',')}`:"",
					!!nNU(raw?.通常請求額) && (raw?.通常請求額 !== '')  ? `￥${raw?.通常請求額.replace("@",',')}`:"",
					!!nNU(raw?.変動金額) && (raw?.変動金額 !== '')  ? `￥${raw?.変動金額.replace("@",',')}`:"",
					!!nNU(raw?.加減算額) && (raw?.加減算額 !== '')  ? `￥${raw?.加減算額.replace("@",',')}`:"",
					!!nNU(raw?.当月消費税額) && (raw?.当月消費税額 !== '')  ? `￥${raw?.当月消費税額.replace("@",',')}`:"",
					!!nNU(raw?.未収累計額) && (raw?.未収累計額 !== '')  ? `￥${raw?.未収累計額.replace("@",',')}`:"",
					!!nNU(raw?.当月請求額) && (raw?.当月請求額 !== '')  ? `￥${raw?.当月請求額.replace("@",',')}`:"",
					!!nNU(raw?.通常請求額1) && (raw?.通常請求額1 !== '')  ? `￥${raw?.通常請求額1.replace("@",',')}`:"",
					!!nNU(raw?.通常請求額2) && (raw?.通常請求額2 !== '')  ? `￥${raw?.通常請求額2.replace("@",',')}`:"",
					!!nNU(raw?.通常請求額3) && (raw?.通常請求額3 !== '')  ? `￥${raw?.通常請求額3.replace("@",',')}`:"",
					!!nNU(raw?.通常請求額4) && (raw?.通常請求額4 !== '')  ? `￥${raw?.通常請求額4.replace("@",',')}`:"",
					!!nNU(raw?.通常請求額5) && (raw?.通常請求額5 !== '')  ? `￥${raw?.通常請求額5.replace("@",',')}`:"",
					!!nNU(raw?.変動金額1) && (raw?.変動金額1 !== '')  ? `￥${raw?.変動金額1.replace("@",',')}`:"",
					!!nNU(raw?.変動金額2) && (raw?.変動金額2 !== '')  ? `￥${raw?.変動金額2.replace("@",',')}`:"",
					!!nNU(raw?.変動金額3) && (raw?.変動金額3 !== '')  ? `￥${raw?.変動金額3.replace("@",',')}`:"",
					!!nNU(raw?.変動金額4) && (raw?.変動金額4 !== '')  ? `￥${raw?.変動金額4.replace("@",',')}`:"",
					!!nNU(raw?.変動金額5) && (raw?.変動金額5 !== '')  ? `￥${raw?.変動金額5.replace("@",',')}`:"",
				]:
					contentTable.map((value) => {
						return null;
					}),
				raw,
			})),
		[],
	);
	const dataTable = useCallback(
		(data) =>
			data.map((raw, key) => ({
				key: raw?.userCode,
				data: [
					raw?.userCode,
					"不存在"
				],
				raw,
			})),
		[],
	);
	const mainActions = [
		{
			// icon: 'exit',
			title: '閉じる',
			onClick: () => setErrorId(null),
		},
	];
	// useEffect(() => {
	// 	if (!!nNU(csvContent)) {
	// 		console.log("Loaded");
	// 		setInvoice(invoiceData(csvContent));
	// 	}
	// },[csvContent]);
	useEffect(() => {
		if (!!nNU(invoice)){
			// console.log(invoice);
			let invoiceData = [];
			if (total > 0) {
				let count = 0;
				for (let i=0;i<invoice.length;i++){
					if(!!nNU(invoice[i]?.data[0])){
						const time = new Date();
						const lastMonthTime = moment().subtract(1,'M').format();
						const thisYear = time.getFullYear();
						const nextYear = thisYear + 1;
						const thisMonth = time.getMonth() + 1;
						const nextMonth = (time.getDay() < 20) ? thisMonth : ((thisMonth + 1) % 12);
						let payDatePos = 0;
						for (let j=1;j<selectDate.length;j++){
							if(selectedDate === selectDate[j]){
								payDatePos = j - 1;
								break;
							}
						}
						payDatePos = 20 + payDatePos;
						const payDate = `${payDatePos} 日`;
						const thisDate = time.getDate();
						let monthString = `${thisMonth}`;
						// let monthString = (time.getDay() < 20) ? `${thisMonth > 1 ? (thisMonth - 1) : 12}` : `${thisMonth}`;
						let dateString = `${thisDate}`;
						if(monthString.length < 2){
							monthString = `0${monthString}`;
						}
						if(dateString.length < 2){
							dateString = `0${dateString}`;
						}
						const issueDate = `${thisYear} 年 ${monthString} 月 ${dateString} 日 `;
						monthString = `${nextMonth}`;
						if(monthString.length < 2){
							monthString = `0${monthString}`;
						}
						dateString = `${payDate}`;
						if(dateString.length < 2){
							dateString = `0${dateString}`;
						}
						const transDate = (nextMonth === 1) ? `${nextYear} 年 ${monthString} 月 ${dateString}` : `${thisYear} 年 ${monthString} 月 ${dateString} `;
						const invoiceMonth = (time.getDay() < 20) ? `（${formatDate(lastMonthTime, 'YYYY年MM月分')}）` : `（${formatDate(time, 'YYYY年MM月分')}）`;
						let data = {
							userCode: invoice[i]?.data[0],
							postCode: invoice[i]?.data[1],
							addressLine1: invoice[i]?.data[2],
							addressLine2: invoice[i]?.data[3],
							addressLine3: invoice[i]?.data[4],
							username: invoice[i]?.data[5],
							issueDate: issueDate,
							transferDate: transDate,
							invoiceTotal: invoice[i]?.data[12],
							invoiceMonth: invoiceMonth,
							content:
								itemIndexTable.map((value) => {
									let data = "";
									if (value > 0) {
										if ((invoiceTable[value] !== '未定')) {
											data = invoiceTable[value];
										}
									}
									return data;
								}),
							volume:
								itemIndexTable.map((value) => {
									let data = "";
									if (value > 0) {
										if ((invoiceTable[value] !== '未定')) {
											data = invoice[i]?.data[value];
											if (data === "") {
												data = "￥0";
											}
										}
									}
									return data;
								}),
						};
						invoiceData.push(data);
						count = count + 1;
						if (count === total) {
							break;
						}
					}
				}

				if (count > 0) {
					let payload = {
						invoice: invoiceData,
					};//invoiceData[0];
					showConfirm({
						body: string.APP_INVOICE_START_CONFIRM,
						defaultAction: () => {
							sendPost({
								url: Urls.payment.invoice,
								body: payload,
							}).then((res) => {
								const { status, result } = res;
								if (status === 'SUCCESS') {
									if (result.length < 1) {
										showToast(string.APP_INVOICE_START_SUCCESS, 'success');
									} else {
										showToast(string.APP_INVOICE_START_ERROR, 'error');
										setErrorId(result);
									}
								}
								// onUpdated(res);
							}).catch((e) => {

							});
						},
					});
				}
				console.log(invoiceData);
			}
		}
	},[invoice]);
	useEffect(() => {
		let date = [];
		date.push('未設定');
		if (selectDate.length === 0) {
			const time = new Date();
			const thisYear = time.getFullYear();
			const nextYear = thisYear + 1;
			const thisMonth = time.getMonth() + 1;
			const nextMonth = (time.getDay() < 20) ? thisMonth : ((thisMonth + 1) % 12);
			const transYM = (nextMonth === 1) ? `${nextYear}年${nextMonth}月` : `${thisYear}年${nextMonth}月`;
			const startDate = new Date((nextMonth === 1) ? `${nextYear}/${nextMonth}/20`:`${thisYear}/${nextMonth}/20`);
			let wDay = startDate.getDay();
			// transferDate.map((value) => (date.push(`${yyMm}${value}${weeksDay[wDay]}`)));
			transferDate.map((value) => {
				date.push(`${transYM}${value}（${weeksDay[wDay]}）`);
				wDay = (wDay + 1) % 7;
				return date;
			});
			setSelectDate(date);
		}
	},[selectDate]);
  useEffect(() => {
    setInputFile(document.getElementById("ImportCsvFile"));
  }, []);

  //------------------------------------RETURN---------------------------------------------------------
	return (
		<>
			<Page
				title={string.APP_INVOICE_PAGE_TITLE}
				body = {
					<>
						<Form>
							<FormControls
                controls={[
                  (!!nNU(selectDate) && {
                    id: 'transferDate',
                    title: string.APP_INVOICE_TRANSFER_DATE,
										type:'selection',
										options: selectDate.map((value) => ({ select: value })),
										defaultValue:selectDate[0],
										onChange: (e) => {
											const select = e.target.value;
											setSelectedDate(select);
										},
                  }),
									{
										id: 'CSVFile',
										title: string.APP_INVOICE_CSV_TITLE,
										readOnly: true,
										placeholder: !!nNU(csvFile) ? csvFile?.name:'CSVファイルを取込ください。',
									},
                ]}
                footer={<></>}
							/>
              <Row
								className="form-button-row"
								style={{
									paddingTop:'10px',
								}}
							>
								<input
									type="file"
									id="ImportCsvFile"
									accept=".csv"
									// placeholder="test"
									onChange={onCsvImport}
									className="d-none"
								/>
                {!isMonitorOnly && (<Button
									onClick={handleUpload}
									style={{
										paddingTop:'10px',
										minWidth: '100px',
									}}
									>{string.APP_INVOICE_CSV_IMPORT}</Button>)}
              </Row>
							{ (total > 0) && !!nNU(csvFile) && !!nNU(selectedDate) && (selectedDate !== selectDate[0]) ? (
								<Row
									className="form-button-row"
									style={{
										paddingTop:'10px',
									}}
								>
									<Button
										onClick={onSubmit}
										style={{
											minWidth: '100px',
										}}
									>{string.APP_INVOICE_ISSUE}</Button>
								</Row>) :
								null
							}
						</Form>
					</>
				}
			/>
			<Modal
				show={!!errorId}
				onHide={() => setErrorId(null)}
				body = {
					<>
						{!!errorId && (
							<Page
								title={string.APP_INVOICE_CUSTOMER_ID_ERROR}
								body = {
									<>
										<Table
											className="nowrap"
											mainActions={mainActions}
											headers={[
												"顧客番号",
												"詳細"
											]}
											data={dataTable(errorId)}
											isPaging={false}
										/>
									</>
								}
							/>
						)}
					</>
				}
			/>
		</>
	);
};

export default SendInvoice;